// 个人支付模块
export default {
    Mywallet: {
        MyAccount: '我的账户',
        AvailableBalance: '可用余额',
        RMB: '元',
        Withdrawal: '提现',
        ExpenditureAmount: '支出金额',
        TransactionRecords: '交易记录',
        ApplyForInvoice: '申请发票',
        Withdrawing: '提现中',
        BalanceWithdrawalProcess: '处于提现流程的余额',
        InUse: '使用中',
        OccupationAmount: '用户红包、样本收集等占用金额',
        FunctionTemporarilyOpen: '该功能暂为开放',
        AccountBalance: '账户余额',
        TransactionType: '交易类型',
        All: '全部',
        Other: '其他',
        TextMessage: '短信',
        Mail: '邮件',
        RedEnvelope: '红包',
        Recharge: '充值',
        CapitalFlow: '资金流向',
        Income: '收入',
        Expenditure: '支出',
        Time: '时间',
        TransactionName: '交易名称',
        PaymentMethod: '支付方式',
        SMSBalance: '短信余额',
        SMSSending: '短信发送',
        SMSVerification: '短信验证',
        SMSGift: '短信赠送',
        SMSPurchase: '短信购买',
        UsageDetails: '使用明细',
        SMSChangesPiece: '短信变更(条)',
        SMSBalancePiece: '短信余额(条)',
        ChangeType: '变更类型',
        MailBalance: '邮件余额',
        EmailSending: '邮件发送',
        EmailGifts: '邮件赠送',
        EmailPurchase: '邮件购买',
        EmailReturn: '邮件退回',
        EmailChangesPiece: '邮件变更(条)',
        EmailBalancePiece: '邮件余额(条)',
        Sending: '发送',
        Give: '赠送',
        Purchase: '购买',
        TestVerify: '验证',
        Return: '退回',
        Mailbox: '邮箱',
        AccountRecharge: '账户充值',
        RechargeAccount: '充值账户',
        RechargeAmount: '充值金额',
        RechargeLeast10: '最少充值10',
        Alipay: '支付宝',
        WeChat: '微信',
        BankTransfer: '银行转账',
        Payment: '支付',
        ClickPayment: '点击了支付'
    },
  };